import React from "react";
import { Link } from "react-router-dom";

import { routes } from "routes";
import "components/buttons/BaseButton/BaseButton.scss";

import "./MigrateImgurPage.scss";

export const MigrateImgurSuccessPage = (): JSX.Element => {
  document.title = "Migrate from Imgur";

  return (
    <div className="migratePage narrow page">
      <h1>Transfer your content from Imgur</h1>

      <p>Great! We successfully connected your account to Imgur.&nbsp;
      We will now migrate all your contents in the background.&nbsp;
      Imgur has a limit on how fast we can download stuff, so this will take a while,
      depending on the number of contents you have uploaded.&nbsp;
      You will receive an email when the process is over.</p>

      <p>You can probably already see new gifs showing up in the <Link to={routes.manageProfile()}>manage section</Link>.</p>
    </div>
  );
};
